import * as axiosHelper from "./api_helper";

// Create a license user for a customer
export const createLicenseUser = async (customerId) => {
  const data = await axiosHelper.post(
    `/license/${customerId}/license-user`,
    {}
  );
  if (data.isError) {
    throw new Error(data.message);
  }
  return data;
};

// Create a subscription for a customer
export const createSubscription = async (customerId, payload) => {
  // Check if payload is FormData (contains file) or regular object
  if (payload instanceof FormData) {
    const data = await axiosHelper.postFormData(
      `/license/${customerId}/subscriptions`,
      payload
    );
    if (data.isError) {
      throw new Error(data.message);
    }
    return data;
  } else {
    const data = await axiosHelper.post(
      `/license/${customerId}/subscriptions`,
      payload
    );
    if (data.isError) {
      throw new Error(data.message);
    }
    return data;
  }
};

// Get customer subscriptions
export const getSubscriptions = async (customerId, page = 1, limit = 10) => {
  const data = await axiosHelper.get(
    `/license/${customerId}/subscriptions?page=${page}&limit=${limit}`
  );
  if (data.isError) {
    throw new Error(data.message);
  }
  return data;
};

// Check customer subscription status
export const checkSubscriptionStatus = async (customerId) => {
  const data = await axiosHelper.get(
    `/license/${customerId}/subscription-status`
  );
  if (data.isError) {
    throw new Error(data.message);
  }
  return data;
};

// Delete customer subscription
export const deleteSubscription = async (customerId, subscriptionId) => {
  const data = await axiosHelper.del(
    `/license/${customerId}/subscriptions/${subscriptionId}`
  );
  if (data.isError) {
    throw new Error(data.message);
  }
  return data;
};

// Get available products
export const getProducts = async (page = 1, limit = 10) => {
  const data = await axiosHelper.get(
    `/license/products?page=${page}&limit=${limit}`
  );
  if (data.isError) {
    throw new Error(data.message);
  }
  return data;
};

// Mark customer subscription as paid
export const markSubscriptionAsPaid = async (
  customerId,
  subscriptionId,
  payload
) => {
  const data = await axiosHelper.putFormData(
    `/license/${customerId}/subscriptions/${subscriptionId}/mark-paid`,
    payload
  );
  if (data.isError) {
    throw new Error(data.message);
  }
  return data;
};

export const getSubscriptionBillings = async (
  subscriptionId,
  page = 1,
  limit = 10
) => {
  const data = await axiosHelper.get(
    `/license/subscriptions/${subscriptionId}/billings?page=${page}&limit=${limit}`
  );
  if (data.isError) {
    throw new Error(data.message);
  }
  return data;
};

// Freeze/Unfreeze subscription
export const freezeUnfreezeSubscription = async (
  customerId,
  subscriptionId,
  payload
) => {
  const data = await axiosHelper.put(
    `/license/${customerId}/subscriptions/${subscriptionId}/freeze`,
    payload
  );
  if (data.isError) {
    throw new Error(data.message);
  }
  return data;
};
